<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-25 md-small-size-100">
      <md-field>
        <label>{{ $t("communication.filter_by") }}</label>
        <md-select
          @md-selected="getListOptions"
          name="target"
          v-model="data.filter_by"
          id="target"
        >
          <md-option value="Class">{{ $t("common.class") }}</md-option>
          <md-option value="Staff">{{
            $t("communication.full_name_staff_id")
          }}</md-option>
        </md-select>
      </md-field>
    </div>
    <div
      class="md-layout-item md-size-25 md-small-size-100"
      :key="selectedIndex"
    >
      <selection-component
        v-if="data.filter_by"
        :label="data.filter_by"
        :data-list="dataList"
        :track-by-key="displayField"
        @filtering="filterStdUsn"
        ref="selectionsRef"
        @update-selections="updateSelectionsData"
      >
      </selection-component>
    </div>
  </div>
</template>
<script>
import { service_paths } from "@/constants/Services";
import SelectionComponent from "./../Selections";
import omit from "lodash/omit";

export default {
  name: "teacher-option",
  components: { SelectionComponent },
  props: ["data"],
  data() {
    return {
      dataList: [],
      selectedIndex: 0,
      delayTime: "",
      displayField: "",
      trackBy: "",
      currentPath: "",
      query: {
        limit: 100
      }
    };
  },
  methods: {
    getRole() {
      this.$axios.get(`${service_paths.staffs}/roles`).then(response => {
        this.query.role_id = response.data.find(
          role => role.name === "Teacher"
        ).id;
        this.getDataList();
      });
    },
    getListOptions() {
      switch (this.data.filter_by) {
        case "Class": {
          this.currentPath = service_paths.classes;
          this.displayField = "name";
          this.trackBy = "id";
          this.query = { limit: this.query.limit };
          this.getDataList();
          break;
        }
        case "Staff": {
          this.currentPath = `${service_paths.staffs}/filter?order_by=full_name`;
          this.displayField = "full_name";
          this.trackBy = "_id";
          this.query = Object.assign(
            {
              role_id: null,
              fields: ["full_name", "staff_code"]
            },
            this.query
          );
          this.getRole();
          break;
        }
      }
      this.selectedIndex++;
    },
    getDataList() {
      if (this.data.filter_by !== "Staff")
        this.query = omit(this.query, "role_id");
      this.$axios.get(this.currentPath, this.query).then(response => {
        this.dataList = response.data.data;
      });
    },
    setQuery(usnQuery) {
      if (this.data.filter_by === "Staff") {
        return {
          search_key: usnQuery,
          limit: this.query.limit,
          fields: this.query.fields
        };
      }
      return {
        [`${this.displayField}__~`]: usnQuery,
        limit: this.query.limit
      };
    },
    filterStdUsn(usnQuery) {
      this.query = this.setQuery(usnQuery);
      clearTimeout(this.delayTime);
      this.delayTime = setTimeout(() => {
        this.$axios.get(this.currentPath, this.query).then(response => {
          this.dataList = response.data.data;
        });
      }, 200);
    },
    updateSelectionsData(e) {
      this.data.selectedList = e;
    }
  }
};
</script>
